var map = {
	"./about/about.module": [
		"../../../../../src/app/about/about.module.ts",
		1
	],
	"./industry/industry.module": [
		"../../../../../src/app/industry/industry.module.ts",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = "../../../../../src async recursive";


//////////////////
// WEBPACK FOOTER
// C:/Users/Administrator/submit text project/gwin/src async
// module id = ../../../../../src async recursive
// module chunks = 3